import { useState, useCallback, useRef } from 'react';
import useVideoContext from './useVideoContext';
export default function useScreenShareToggle() {
  var _useVideoContext = useVideoContext(),
      room = _useVideoContext.room,
      onError = _useVideoContext.onError,
      onControlEvent = _useVideoContext.onControlEvent;

  var _useState = useState(false),
      isSharing = _useState[0],
      setIsSharing = _useState[1];

  var stopScreenShareRef = useRef(null);
  var shareScreen = useCallback(function () {
    navigator.mediaDevices.getDisplayMedia({
      audio: false,
      video: {
        frameRate: 10,
        height: 1080,
        width: 1920
      }
    }).then(function (stream) {
      var track = stream.getTracks()[0]; // All video tracks are published with 'low' priority. This works because the video
      // track that is displayed in the 'MainParticipant' component will have it's priority
      // set to 'high' via track.setPriority()

      room.localParticipant.publishTrack(track, {
        name: 'screen',
        // Tracks can be named to easily find them later
        priority: 'low' // Priority is set to high by the subscriber when the video track is rendered

      }).then(function (trackPublication) {
        stopScreenShareRef.current = function () {
          room.localParticipant.unpublishTrack(track); // TODO: remove this if the SDK is updated to emit this event

          room.localParticipant.emit('trackUnpublished', trackPublication);
          track.stop();
          setIsSharing(false);
        }; // This comment on github: https://github.com/twilio/twilio-video.js/issues/849
        // suggests not using onended but rather listening for 'stopped' but the 
        // twilio react demo app still uses onended and I can't see why not - no issues so far


        track.onended = stopScreenShareRef.current;
        setIsSharing(true);
      })["catch"](onError);
    })["catch"](function (error) {
      console.error('shareScreen failed', error); // Don't display an error if the user closes the screen share dialog

      if (error.name !== 'AbortError' && error.name !== 'NotAllowedError') {
        onError(error);
      }
    });
  }, [room, onError]);
  var toggleScreenShare = useCallback(function () {
    onControlEvent('toggleScreenShare', {
      isEnabled: !isSharing
    });
    !isSharing ? shareScreen() : stopScreenShareRef.current();
  }, [isSharing, shareScreen, stopScreenShareRef]);
  return [isSharing, toggleScreenShare];
}